/* SW49 — ürün sayfası yardımcıları
   1) Teslimat tarihi aralığı (iş günü, ziyaretçi dilinde)
   2) ABD dışı marketlerde beden etiketinde cm'yi öne alma
   3) Variant değişiminde teslimat bloğunu yeniden hesapla (Dawn section render sonrası)
*/
(function () {
  'use strict';

  function addBusinessDays(start, days) {
    var d = new Date(start.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }

  function fmt(d, lang) {
    try {
      return new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short' }).format(d);
    } catch (e) {
      return d.toLocaleDateString();
    }
  }

  function renderDelivery(root) {
    var els = (root || document).querySelectorAll('[data-sw-delivery]');
    if (!els.length) return;
    var lang = document.documentElement.lang || 'en';
    var now = new Date();
    // 14:00 sonrası siparişler bir sonraki iş gününden sayılır
    if (now.getHours() >= 14) now = addBusinessDays(now, 1);
    els.forEach(function (el) {
      var min = parseInt(el.dataset.min, 10);
      var max = parseInt(el.dataset.max, 10);
      if (isNaN(min) || isNaN(max)) return;
      var a = addBusinessDays(now, min);
      var b = addBusinessDays(now, max);
      var target = el.querySelector('[data-sw-delivery-range]');
      var text = fmt(a, lang) + ' – ' + fmt(b, lang);
      // Yalnızca değiştiyse yaz: aksi halde DOM gözlemcileri döngüye girer.
      if (target && target.textContent !== text) target.textContent = text;
    });
  }

  function metricFirst(root) {
    if (!document.body.dataset.swMetricFirst) return;
    var nodes = (root || document).querySelectorAll(
      '.product-form__input label, .product-form__input option, .sw-sticky-atc option, .quick-add-modal label'
    );
    nodes.forEach(function (n) {
      if (n.dataset.swSwapped) return;
      var txt = n.textContent;
      // "8"×12" / 20×30cm" → "20×30 cm / 8"×12""
      var m = txt.match(/^\s*([^\/]+?)\s*\/\s*([0-9]+\s*[×x]\s*[0-9]+\s*cm)\s*$/i);
      if (m) {
        n.textContent = m[2].replace(/cm$/i, ' cm').replace(/\s+cm/, ' cm') + ' / ' + m[1].trim();
        n.dataset.swSwapped = '1';
      }
    });
  }

  function init(root) {
    renderDelivery(root);
    metricFirst(root);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });

  // Dawn, varyant değişiminde ürün bilgi alanını yeniden render eder.
  // NOT: PUB_SUB_EVENTS constants.js'de `const` olarak tanımlı, window üzerinde değil;
  // bu yüzden typeof ile kontrol edilir. MutationObserver kullanılmaz (döngü riski).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      requestAnimationFrame(function () { init(document); });
    });
  }

  // ---- Koleksiyon sıralama butonları ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sw-sort] .sw-sort__btn');
    if (!btn) return;
    var group = btn.closest('[data-sw-sort]');
    var form = btn.closest('form');
    var select = form ? form.querySelector('select[name="sort_by"]') : null;
    if (!select) return;
    var value = btn.dataset.sort;
    var reverse = btn.dataset.sortReverse;
    if (btn.classList.contains('is-active') && reverse) {
      value = btn.classList.contains('is-reversed') ? btn.dataset.sort : reverse;
    }
    group.querySelectorAll('.sw-sort__btn').forEach(function (b) { b.classList.remove('is-active', 'is-reversed'); });
    btn.classList.add('is-active');
    if (reverse && value === reverse) btn.classList.add('is-reversed');
    if (select.value === value) return;
    select.value = value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
